import { createContext } from 'react';

import { TRACK_EVENTS } from '@mais-retorno-front/hooks/tracking-events';

export const TrackingEventsContext = createContext<{
  trackEvent: (event: TRACK_EVENTS | string, props?: any) => void;
}>({} as any);

export const TrackingEventsProvider = ({ children }) => {
  const trackEvent = (event: TRACK_EVENTS | string, props: any = {}) => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({ event, ...props });
  };

  return (
    <TrackingEventsContext.Provider value={{ trackEvent }}>
      {children}
    </TrackingEventsContext.Provider>
  );
};
